import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { ChangeIconPageRoutingModule } from './change-icon-routing.module';
import { ChangeIconPageComponent } from './change-icon.page';

@NgModule({
  declarations: [ChangeIconPageComponent],
  imports: [CommonModule, FormsModule, IonicModule, ChangeIconPageRoutingModule, MiscModule, NgOptimizedImage]
})
export class ChangeIconPageModule {}
